/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs */

const en_forms_teams_settings_contact_max_simultaneous_contacts = /** @type {(inputs: Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simultaneous Contacts`)
};

const de_forms_teams_settings_contact_max_simultaneous_contacts = /** @type {(inputs: Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal zugelassene zusätzliche Kontakte`)
};

/**
* | output |
* | --- |
* | "Simultaneous Contacts" |
*
* @param {Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_contact_max_simultaneous_contacts = /** @type {((inputs?: Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Contact_Max_Simultaneous_ContactsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_contact_max_simultaneous_contacts(inputs)
	return de_forms_teams_settings_contact_max_simultaneous_contacts(inputs)
});